import * as angular from 'angular';

import { ComponentDefinition, ConnectionPoint } from '../../models/';
import { dateFormatShort } from '../../common/';

class ConnectionPointDetailsController implements angular.IComponentController {
    dateFormat: string;
    isLoading: boolean;
    loadingMessage: string;
    readonly connectionPoint: ConnectionPoint;

    static $inject = [];

    $onInit() {
        this.dateFormat = dateFormatShort;
    }
}

export const wtConnectionPointDetails: ComponentDefinition = {
    componentId: 'wtConnectionPointDetails',
    controller: ConnectionPointDetailsController,
    template: require('./connectionPointDetails.component.html'),
    controllerAs: 'vm',
    bindings: {
        connectionPoint: '<'
    }
};
